export const clientInfo = (state = {}, action) => {
  switch (action.type) {
    case 'SET_CLIENT_INFO':
      return action.data;
    case 'UPDATE_CLIENT_INFO':
      return { ...state, ...action.data };
    case 'CLEAR_CLIENT_INFO':
      return {};
    default:
      return state;
  }
};
